export default "__VITE_ASSET__BxFugBue__"